/**
 * see https://sketch.slack.com/archives/C1XGDTD0X/p1587644498173300
 */
export const getCanAdminister = (shareRights: {
  userCanUpdateSettings: boolean
}) => shareRights.userCanUpdateSettings
